import { processResponse, msEndpoint, urlFilters } from "./common";

export const apiGetProduct = filters =>
  fetch(urlFilters(`${msEndpoint}/shopping/products`, filters), {
    method: "GET"
  }).then(processResponse);

